import { CurrencyThbIcon } from './CurrencyThbIcon';

/**
 * author: Michael Irigoyen
 * id F9875997-F68E-4AE3-9B85-E8DFB6E0D054
 * name currency-thb
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-thb.svg
 * tags
 * - Banking 
 */
export const CurrencyThaiBahtIcon = CurrencyThbIcon;
export default CurrencyThaiBahtIcon